import * as React from "react";

import { UitkFigure, UitkFigureAspectRatioType } from "uitk-react-images";

import { EntityType, HeartButton } from "components/shared/HeartButton/HeartButton";
import { MediaAttribution } from "components/utility/MediaAttributionUtil";
import { LazyLoadedImage } from "components/utility/LazyLoadedImage/LazyLoadedImage";

import { NeighborhoodCardMediaProps } from "../typings";
import { withStores } from "stores";

export const NeighborhoodCardMedia = withStores("thumbor")((props: NeighborhoodCardMediaProps) => {
  const { context, id, regionName, media, showFavorite, attributionType, renderAttributionText, thumbor } = props;

  const { mediaUrl } = media;

  const neighborhoodImageUrl = mediaUrl
    ? thumbor.safelyGenerateThumborizedImageUrl(mediaUrl, 350, 192, context, undefined, true)
    : "";

  const attribution =
    attributionType === "destination"
      ? MediaAttribution(media, regionName)
      : MediaAttribution(media, regionName, renderAttributionText);

  return (
    <UitkFigure ratio={props.ratio || UitkFigureAspectRatioType.R16_9} className="all-image-fit-cover">
      <LazyLoadedImage src={neighborhoodImageUrl} alt={attribution?.attributionAltText} offset={125} />

      {attribution?.attributionText}

      {showFavorite && (
        <HeartButton
          moduleName="TG.LP.Dest.Neighborhoods"
          heartableEntity={{
            id,
            name: regionName,
            entityType: EntityType.NEIGHBORHOOD,
            payload: { favoriteId: id },
          }}
        />
      )}
    </UitkFigure>
  );
});
